// src/components/Footer/Footer.jsx
import React from 'react';
import './Footer.css';
import logoImg from '../../assets/Logo2.png';

const Footer = () => {
  return (
    <footer className="footer-section text-white mx-3 mx-lg-4 mb-4 rounded-5 overflow-hidden mt-5">
      <div className="container py-5 px-lg-5">

        {/* --- ROW 1: Logo & Description --- */}
        <div className="row align-items-center pt-5 mb-5">
          <div className="col-lg-2 col-md-3 mb-3 mb-md-0">
            <a href="/" className="d-block">
              <img src={logoImg} alt="Dynamic Stamping" className="footer-logo" />
            </a>
          </div>
          <div className="col-lg-8 col-md-9">
            <p className="footer-desc mb-0 text-white-50">
              Dynamic Stamping Pvt. Ltd. is a precision automotive component manufacturer specializing
              in metal stamping, tooling, welding, and assembly solutions for OEMs and Tier-1 suppliers.
            </p>
          </div>
        </div>

        {/* --- ROW 2: Contact Info --- */}
        <div className="row mb-5">
          <div className="col-12 mb-4">
            <h6 className="text-white-50 mb-3">Dynamic Stamping Pvt. Ltd.</h6>
          </div>

          <div className="col-lg-5 col-md-6 mb-4 mb-md-0">
            <p className="text-white mb-0 small" style={{ lineHeight: '1.8' }}>
              NO : 99, SURVEY NO.561 / 1C-2,<br />
              PAPPARAMBAKKAM VILLAGE<br />
              THIRUVALLUR (TALUK & DISTRICT )– 602 025,<br />
              TAMIL NADU<br />
              INDIA
            </p>
          </div>

          <div className="col-lg-4 col-md-6">
            <p className="mb-2">
              <a href="mailto:shanmugaperumal@dynamic-stamping.com" className="text-white text-decoration-none small">
                shanmugaperumal@dynamic-stamping.com
              </a>
            </p>
            <p className="mb-0">
              <a href="tel:+919840314831" className="text-white text-decoration-none fw-bold">
                +91 98403 14831
              </a>
            </p>
          </div>
        </div>


        {/* --- ROW 3: Bottom Copyright --- */}
        <div className="border-top border-white-10 pt-4">
          <div className="row align-items-center small text-white-50">
            <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
              &copy; 2025 Dynamic Stamping Pvt. Ltd. All rights reserved.
            </div>

            <div className="col-md-6 text-center text-md-end">
              <a href="/" className="text-white-50 text-decoration-none me-3">Terms and conditions</a> |
              <a href="/" className="text-white-50 text-decoration-none ms-3">Privacy Policy</a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;